import type { DetectedIssueType } from '../moderation'

export enum SafetyReportInternalType {
  UserProfile = 'user-profile',
  RudeShocking = 'rude-shocking',
  InappropriatelyPersonal = 'inappropriately-personal',
  Insensitivity = 'insensitivity',
  UnintentionalDisruption = 'unintentional-disruption',
  InformationSharing = 'information-sharing',
  UnderAge = 'under-age',
  Bullying = 'bullying',
  PotentialGrooming = 'potential-grooming',
  Benign = 'benign',
  Duplicate = 'duplicate',
  Other = 'other',
  NotSafetyIssue = 'not-a-safety-issue',
  FlaggedOneOnOneSession = 'flagged-one-on-one',
  Spam = 'spam',
  ZoomSessionRemoval = 'zoom-session-removal',
  PlatformAbuse = 'platform-abuse',
}

export enum SafetyReportStatus {
  None = 'none',
  AwaitingUserResponse = 'awaiting-user-response',
  NeedsAction = 'needs-action',
  InProgress = 'in-progress',
  Resolved = 'resolved',
}

export type SafetyReportAction = {
  timestamp: string
  status: SafetyReportStatus
  userId: number | null
  userName: string | null
  comment: string
}

export enum SafetyReportType {
  Harassment = 'harassment',
  InappropriateBehavior = 'inappropriate-behavior',
  LeakedPersonalInfo = 'leaked-personal',
  ContentQuality = 'content-quality',
  Spam = 'spam',
  Other = 'other',
}

export const SAFETY_REPORT_TYPE_TO_DETECTED_ISSUE_TYPE: Record<
  SafetyReportType,
  DetectedIssueType
> = {
  [SafetyReportType.Harassment]: 'made-me-uncomfortable-other',
  [SafetyReportType.InappropriateBehavior]: 'made-me-uncomfortable-other',
  [SafetyReportType.LeakedPersonalInfo]: 'sharing-personal-information',
  [SafetyReportType.ContentQuality]: 'content-violates-guidelines-other',
  [SafetyReportType.Spam]: 'repetitive-or-frivolous-communication',
  [SafetyReportType.Other]: 'other',
}

export const SAFETY_REPORT_INTERNAL_TYPE_TO_DETECTED_ISSUE_TYPE: Record<
  SafetyReportInternalType,
  DetectedIssueType
> = {
  [SafetyReportInternalType.UserProfile]: 'content-violates-guidelines-other',
  [SafetyReportInternalType.InformationSharing]: 'sharing-personal-information',
  [SafetyReportInternalType.UnderAge]: 'user-under-13-peer-report',
  [SafetyReportInternalType.PotentialGrooming]: 'suspicious-interactions-with-minor',
  [SafetyReportInternalType.NotSafetyIssue]: 'other',
  [SafetyReportInternalType.FlaggedOneOnOneSession]: 'other',
  [SafetyReportInternalType.Spam]: 'repetitive-or-frivolous-communication',
  [SafetyReportInternalType.RudeShocking]: 'severely-crude-or-inappropriate-behavior',
  [SafetyReportInternalType.InappropriatelyPersonal]: 'crossing-privacy-boundaries-other',
  [SafetyReportInternalType.Insensitivity]: 'disrespectful-behavior',
  [SafetyReportInternalType.UnintentionalDisruption]: 'disrespectful-behavior',
  [SafetyReportInternalType.Bullying]: 'disrespectful-behavior',
  [SafetyReportInternalType.Benign]: 'other',
  [SafetyReportInternalType.Duplicate]: 'other',
  [SafetyReportInternalType.Other]: 'other',
  [SafetyReportInternalType.ZoomSessionRemoval]: 'other',
  [SafetyReportInternalType.PlatformAbuse]: 'gaming-sp-or-volunteer-hours',
}
